// extracted by mini-css-extract-plugin
export default {"box_showcase":"box_box_showcase__YyiSZ","box":"box_box__RwCN-"};